import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AddOrEditGroup } from '../../pages/chat/addOrEditGroup';
import { useNavigate } from "react-router-dom";

interface ChatModalsProps {
    showGroupModal: boolean;
    setShowGroupModal: React.Dispatch<React.SetStateAction<boolean>>;
    selectedGroup: any;
    setSelectedGroup: React.Dispatch<React.SetStateAction<any>>;
    handleRefreshFlag: () => void;
    showViewDealModal: boolean;
    setShowViewDealModal: React.Dispatch<React.SetStateAction<boolean>>;
    viewDealHighlightSection?: string | null;
    setViewDealHighlightSection?: React.Dispatch<React.SetStateAction<string | null>>;
    selectedDealForView: any;
    onViewProfile: (profileId?: string | number | null) => void;
}

export const ChatModals: React.FC<ChatModalsProps> = ({
    showGroupModal,
    setShowGroupModal,
    selectedGroup,
    setSelectedGroup,
    handleRefreshFlag,
    showViewDealModal,
    setShowViewDealModal,
    viewDealHighlightSection,
    setViewDealHighlightSection,
    selectedDealForView,
    onViewProfile,
}) => {
    const { t } = useTranslation('chat');
    const navigate = useNavigate();

    const handleGroupModalClose = () => {
        setShowGroupModal(false);
        handleRefreshFlag();
    };

    const viewDealId = selectedDealForView?.id;

    useEffect(() => {
        if (!showViewDealModal || !viewDealId) return;

        const highlightSuffix = viewDealHighlightSection
            ? `?highlight=${encodeURIComponent(viewDealHighlightSection)}`
            : "";
        navigate(`/deal/view/${viewDealId}${highlightSuffix}`);
        setShowViewDealModal(false);
        setViewDealHighlightSection?.(null);
    }, [
        showViewDealModal,
        viewDealId,
        viewDealHighlightSection,
        navigate,
        setShowViewDealModal,
        setViewDealHighlightSection,
    ]);

    return (
        <>
            {showGroupModal && (
                <AddOrEditGroup
                    isOpen={showGroupModal}
                    onClose={handleGroupModalClose}
                    group={selectedGroup}
                    onViewProfile={onViewProfile}
                    onSave={() => {
                        handleRefreshFlag();
                        setShowGroupModal(false);
                        setSelectedGroup(null);
                    }}
                />
            )}
        </>
    );
};
